import _ from "lodash";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  apiPrefix,
  ConnectionService,
  httpMethodType,
} from "./Connecion.service";

const RESOURCE = "auth/Organization";

dayjs.extend(utc);
dayjs.extend(timezone);

class AuthOrganizationService extends ConnectionService {
  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async searchIndexOrg(orgId, params) {
    const url = `${this.basedUrl}/${orgId}/searchOrg`;
    return super.sendRequest(url, { params }, true);
  }

  async getOrgBootstrap(orgId) {
    const url = `${this.basedUrl}/${orgId}/bootstrap`;
    return super.sendRequest(url, {}, true);
  }

  async generateOrgReport(orgId) {
    const localTimezone = dayjs();

    const config = {
      encode: false,
      params: {
        timezone: localTimezone.format("Z"),
      },
    };

    const url = `${this.basedUrl}/${orgId}/organizationList`;
    return super.sendRequest(url, config, false);
  }

  async downloadGeneratedOrgReport(orgId) {
    const config = {
      params: {
        id: orgId,
      },
    };

    const url = `${this.basedUrl}/${orgId}/organizationList/download`;
    return super.sendRequest(url, config, false);
  }

  async getCoTermData(orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkLicenseCoTermination`;
    return super.sendRequest(url, {}, true);
  }

  async getCalculateData(orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkLicenseCoTermination/Calculate`;
    return super.sendRequest(url, {}, true);
  }

  async toCoTerm(data) {
    const postData = {
      userConsent: true,
      hashCode: data.hashCode,
    };
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(postData),
    };

    const url = `${this.basedUrl}/${data.id}/bulkLicenseCoTermination`;
    return super.sendRequest(url, config, true);
  }

  async downloadCoTerm(orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkLicenseCoTermination/Outcome`;
    return super.sendRequest(url, {}, true);
  }

  async getLicenseOverview(orgId) {
    const url = `${this.basedUrl}/${orgId}/licenseOverview`;
    return super.sendRequest(url, {}, true);
  }

  async bindBulkLicense(orgId, file) {
    const url = `${this.basedUrl}/${orgId}/bulkLicenseBind`;
    const formData = new FormData();
    formData.append("csvFile", file);

    const config = {
      method: httpMethodType.post,
      headers: {},
      body: formData,
    };
    return super.sendRequest(url, config, true);
  }

  async bindLicense(orgId, data) {
    const url = `${this.basedUrl}/${orgId}/licenseBind`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };
    return super.sendRequest(url, config, true);
  }

  async fetchUserList(orgId) {
    const url = `${this.basedUrl}/User`;
    const config = {
      params: {
        organizationId: orgId,
      },
    };
    return super.sendRequest(url, config, true);
  }

  async suspendBulkLicense(data) {
    const url = `${this.basedUrl}/bulkLicenseSuspend`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };
    return super.sendRequest(url, config, true);
  }

  async migrateBulkLicense(data) {
    const url = `${this.basedUrl}/bulkLicenseMigrate`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };
    return super.sendRequest(url, config, true);
  }

  async getMetaDataSet(orgId) {
    const url = `${this.basedUrl}/${orgId}/MetaDataSets`;
    return super.sendRequest(url, {}, true);
  }

  async addOrUpdateMetadataSet(orgId, metadataSetId = null, payload) {
    let url;
    if (!metadataSetId) url = `${this.basedUrl}/${orgId}/MetaDataSet`;
    else url = `${this.basedUrl}/${orgId}/MetaDataSet/${metadataSetId}`;

    const formData = new FormData();

    formData.append("name", payload.name);
    payload.issuer && formData.append("issuer", payload.issuer);
    payload.loginUrl && formData.append("loginUrl", payload.loginUrl);
    payload.logoutUrl && formData.append("logoutUrl", payload.logoutUrl);
    payload.idpCertFingerprint &&
      formData.append("idpCertFingerprint", payload.idpCertFingerprint);

    if (payload.idpCertFile) {
      formData.append("idpCertFile", payload.idpCertFile);
      formData.append("idpCertFileName", payload.idpCertFileName);
    }

    if (payload.idpMetaDataXmlFile) {
      formData.append("idpMetaDataXmlFile", payload.idpMetaDataXmlFile);
      formData.append("idpMetaDataXmlFileName", payload.idpMetaDataXmlFileName);
    }

    const config = {
      method: !metadataSetId ? httpMethodType.post : httpMethodType.put,
      headers: {},
      body: formData,
    };

    return super.sendRequest(url, config, true);
  }

  async updateMetaDataSetStatus(orgId, payload) {
    const url = `${this.basedUrl}/${orgId}/MetaDataSet/bulkEnable`;
    const config = {
      method: httpMethodType.put,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async deleteMetaDataSet(orgId, payload) {
    const url = `${this.basedUrl}/${orgId}/MetaDataSet/bulkDelete`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async getSamlRoles(orgId) {
    const url = `${this.basedUrl}/${orgId}/SamlRoles`;
    return super.sendRequest(url, {}, true);
  }

  async addSamlRole(orgId, payload) {
    const url = `${this.basedUrl}/${orgId}/SamlRole`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async upadteSamlRole(orgId, samlRoleId, payload) {
    const url = `${this.basedUrl}/${orgId}/SamlRole/${samlRoleId}`;
    const config = {
      method: httpMethodType.put,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async deleteSamlRole(orgId, payload) {
    const url = `${this.basedUrl}/${orgId}/SamlRole/bulkDelete`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async getSmsConfig(orgId) {
    const url = `${this.basedUrl}/${orgId}/SmsConfig`;
    return super.sendRequest(url, {}, true);
  }

  async addOrUpdateSmsConfig(orgId, smsConfigId = null, payload) {
    let url;
    if (!smsConfigId) url = `${this.basedUrl}/${orgId}/SmsConfig`;
    else url = `${this.basedUrl}/${orgId}/SmsConfig/${smsConfigId}`;

    const config = {
      method: !smsConfigId ? httpMethodType.post : httpMethodType.put,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async deleteSmsConfig(orgId, payload) {
    const url = `${this.basedUrl}/${orgId}/smsConfig/bulkDelete`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async getSyslog(orgId) {
    const url = `${this.basedUrl}/${orgId}/config/syslog`;
    return super.sendRequest(url, {}, true);
  }

  async addOrUpdateSyslog(orgId, syslogId = null, payload) {
    let url;
    if (!syslogId) url = `${this.basedUrl}/${orgId}/config/syslog`;
    else url = `${this.basedUrl}/${orgId}/config/syslog/${syslogId}`;

    const config = {
      method: !syslogId ? httpMethodType.post : httpMethodType.put,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async deleteSyslog(orgId, payload) {
    const url = `${this.basedUrl}/${orgId}/config/syslog/bulkDelete`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async getNetworkViewList(orgId, params) {
    const url = `${this.basedUrl}/${orgId}/networkview/list`;
    return super.sendRequest(url, { params }, true);
  }

  async createOrg(data) {
    const url = `${this.basedUrl}`;
    const config = {
      method: httpMethodType.post,
    };
    if (data.icon) {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("type", data.type);
      formData.append("orgType", data.orgType);
      formData.append("owner", data.owner);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("icon", data.icon);
      config.body = formData;
      config.headers = {};
    } else {
      config.body = JSON.stringify(data);
    }
    return super.sendRequest(url, config, true);
  }

  async updateOrg(orgId, data) {
    const url = `${this.basedUrl}/${orgId}`;
    const config = {
      method: httpMethodType.put,
      body: JSON.stringify(data),
    };
    return super.sendRequest(url, config, true);
  }

  async updateOrgIcon(orgId, data) {
    // create&update
    const url = `${this.basedUrl}/${orgId}/icon`;

    const formData = new FormData();
    formData.append("icon", data.icon);
    const config = {
      method: httpMethodType.post,
      headers: {},
      body: formData,
    };
    return super.sendRequest(url, config, true);
  }

  async deleteOrgIcon(orgId) {
    const url = `${this.basedUrl}/${orgId}/icon`;
    const config = {
      method: httpMethodType.delete,
    };
    return super.sendRequest(url, config, true);
  }

  async asyncDelete(orgId) {
    const url = `${this.basedUrl}/${orgId}/asyncDelete`;
    const config = {
      method: httpMethodType.delete,
    };
    return super.sendRequest(url, config, true);
  }

  async addDeviceCsv(orgId, file) {
    const url = `${this.basedUrl}/${orgId}/preRegisterCsv`;
    const formData = new FormData();
    formData.append("csvFile", file);

    const config = {
      method: httpMethodType.post,
      headers: {},
      body: formData,
    };
    return super.sendRequest(url, config, true);
  }

  async bulkAssign(data, orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkAssign`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }
  async bulkAssignToExistedSite(data, orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkAssignToExistedSite`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }

  async bulkAssignToNewOrg(data, orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkAssignToNewOrg`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }
  async bulkAssignToNewSite(data, orgId) {
    const url = `${this.basedUrl}/${orgId}/bulkAssignToNewSite`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }

  async getDeviceOverview(orgId) {
    const url = `${this.basedUrl}/${orgId}/licenseOverview`;
    return super.sendRequest(url, {}, true);
  }

  async searchOrg(orgId, orgName, skip, limit) {
    const url = `${this.basedUrl}/${orgId}/searchOrg?name=${orgName}&skip=${skip}&limit=${limit}`;
    return super.sendRequest(url, {}, true);
  }

  async getDevicelist(
    orgId,
    deviceTotalCount,
    skip,
    sort,
    reverse,
    isOrgLevel,
    filter
  ) {
    const deviceStats = { online: 1, offline: 0, dormant: -1 };
    const parameterStringTransfer = (key, value) => {
      let transferKey = "";
      let transferValue = "";

      switch (key) {
        case "onlineStatus":
          transferKey = "status";
          if (value === "All") transferValue = "All";
          else transferValue = deviceStats[value.toLowerCase()];
          break;
        case "orgName":
          transferKey = "orgName";
          transferValue = value;
          break;
        case "productCategory":
          transferKey = "productCategory";
          if (value === "All") transferValue = "All";
          else transferValue = value.toUpperCase();
          break;
        case "modelName":
          transferKey = "model";
          if (value === "All") transferValue = "All";
          else transferValue = value.toUpperCase();
          break;
        case "used":
          if (value === "Both") {
            transferKey = "";
            transferValue = "";
          } else {
            transferKey = "use";
            transferValue = value.toLowerCase() === "used" ? "used" : "unused";
          }
          break;
        case "expirationTimeStamp":
          if (value === "All") {
            transferKey = "";
            transferValue = "";
          } else {
            transferKey = "expirationDate";
            transferValue = dayjs().add(value, "day").valueOf();
          }
          break;
        case "macAddress":
          transferKey = "mac";
          transferValue = value;
          break;
        case "uid":
          transferKey = "uid";
          transferValue = value;
          break;
        case "serialNumber":
          transferKey = "serial";
          transferValue = value;
          break;
        default:
      }
      return [transferKey, transferValue];
    };
    const genParameters = (filter) => {
      let parameterString = "";
      let operator = "";
      if (_.isEmpty(filter)) return "status=All&productCategory=All&model=All"; // if first fetch data
      const defaultFilter = {
        onlineStatus: "All",
        productCategory: "All",
        modelName: "All",
      };
      const combinedFilter = { ...defaultFilter, ...filter };
      for (const key in combinedFilter) {
        operator = parameterString !== "" ? "&" : "";
        const [transferKey, transferValue] = parameterStringTransfer(
          key,
          combinedFilter[key]
        );
        if (transferKey === "" && transferValue === "") continue;
        parameterString =
          parameterString + operator + `${transferKey}=${transferValue}`;
      }

      return parameterString;
    };
    const sortArgument =
      sort === ""
        ? ""
        : sort === "modelName"
        ? `&sort=deviceModelId`
        : `&sort=${sort}`;

    const parameters = genParameters(filter);
    const url = isOrgLevel
      ? `${this.basedUrl}/${orgId}/organization/device?status=All&productCategory=All&model=All&skip=${skip}&limit=${deviceTotalCount}&reverse=${reverse}${sortArgument}`
      : `${this.basedUrl}/${orgId}/organization/device?${parameters}&skip=${skip}&limit=${deviceTotalCount}&reverse=${reverse}${sortArgument}`;
    return super.sendRequest(url, {}, true);
  }
}

export default new AuthOrganizationService();
